var React = require('react');

function LocationInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.84737 0.553711C5.61306 0.553711 2.98169 3.18507 2.98169 6.41938C2.98169 10.4846 8.85313 17.4287 8.85313 17.4287C8.85313 17.4287 14.713 10.2846 14.713 6.41938C14.713 3.18507 12.0818 0.553711 8.84737 0.553711ZM10.6172 8.13685C10.1292 8.62475 9.48832 8.86875 8.84737 8.86875C8.20652 8.86875 7.56547 8.62475 7.07767 8.13685C6.10178 7.16106 6.10178 5.57326 7.07767 4.59737C7.55022 4.12461 8.17881 3.86423 8.84737 3.86423C9.51592 3.86423 10.1444 4.12471 10.6172 4.59737C11.5931 5.57326 11.5931 7.16106 10.6172 8.13685Z","fill":"#FF0000"}));
}

LocationInline.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = LocationInline;

LocationInline.default = LocationInline;
